<div class="checkbox-wrapper">
  <mat-checkbox color="primary" [disabled]="params.disabled" [checked]="params.value" (change)="valueChanged($event)"></mat-checkbox>
</div>
